import { FC } from 'react'

const AppcastDisclaimer: FC<{ className: string }> = ({ className }) => (
  <p className={className} data-testid="apply-disclaimer" data-pw="apply-disclaimer">
    By applying, you consent to your information being processed by Appcast and shared with the employer. Appcast’s{' '}
    <a href="https://www.appcast.io/privacy-policy/" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>{' '}
    and{' '}
    <a href="https://www.appcast.io/legal/?job-seeker-terms-of-use" target="_blank" rel="noopener noreferrer">
      Job Seeker Terms of Use
    </a>{' '}
    apply.
  </p>
)

export default AppcastDisclaimer
